function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M92.2,93.7c-0.4,0-0.8-0.2-1.1-0.5L46.9,49.1L2.7,93.3c-0.6,0.6-1.6,0.6-2.2,0c-0.6-0.6-0.6-1.6,0-2.2l44.2-44.2L0.5,2.7 c-0.6-0.6-0.6-1.6,0-2.2s1.6-0.6,2.2,0l44.2,44.2L91.1,0.5c0.6-0.6,1.6-0.6,2.2,0c0.6,0.6,0.6,1.6,0,2.2L49.1,46.9l44.2,44.2 c0.6,0.6,0.6,1.6,0,2.2C93,93.6,92.6,93.7,92.2,93.7z"
})));

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.7 93.7",
    style: {
      enableBackground: "new 0 0 93.7 93.7"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.05b6c7e2.svg";
export { SvgClose as ReactComponent };